var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-nav-item',{staticClass:"theme-switcher",on:{"click":function($event){return _setup.themeStore.updateTheme()}}},[_vm._t("icon",function(){return [_c('i',{staticClass:"icon-nav fas",class:_setup.themeStore.getCurrentIcon})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }